import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomeScreen from './components/screens/HomeScreen/HomeScreen';
import LoginScreen from './components/screens/LoginScreen/LoginScreen';
import SearchResults from './components/screens/SearchResults/SearchResults';
import ProviderDetail from './components/screens/ProviderDetail/ProviderDetail';
import ListDetail from './components/screens/ListDetail/ListDetail';
import MedicationDetail from './components/screens/MedicationDetail/MedicationDetail';
import ProcedureDetail from './components/screens/ProcedureDetail/ProcedureDetail';
import SpecialtyDetail from './components/screens/SpecialtyDetail/SpecialtyDetail';
import AISearchResults from './components/screens/AISearchResults/AISearchResults';
import AISearchResultList from './components/screens/AISearchResultList/AISearchResultList';
import AISearchFollowup from './components/screens/AISearchFollowup/AISearchFollowup';
import AISearchResultDetail from './components/screens/AISearchResultDetail/AISearchResultDetail';
import SavedScreen from './components/screens/SavedScreen/SavedScreen';
import ClaimsSummaryScreen from './components/screens/ClaimsSummaryScreen/ClaimsSummaryScreen';
import PastClaimsScreen from './components/screens/PastClaimsScreen/PastClaimsScreen';
import ClaimsDetailScreen from './components/screens/ClaimsDetailScreen/ClaimsDetailScreen';
import DisputeClaimScreen from './components/screens/DisputeClaimScreen/DisputeClaimScreen';
import ProfileScreen from './components/screens/ProfileScreen/ProfileScreen';
import ProfileContactInformationScreen from './components/screens/ProfileContactInformationScreen/ProfileContactInformationScreen';
import ProfileSubscriptionScreen from './components/screens/ProfileSubscriptionScreen/ProfileSubscriptionScreen';
import ProfileNotificationsSettingScreen from './components/screens/ProfileNotificationsSettingScreen/ProfileNotificationsSettingScreen';
import ProfilePaymentMethodsScreen from './components/screens/ProfilePaymentMethodsScreen/ProfilePaymentMethodsScreen';
import ProfileLinkedAccountsScreen from './components/screens/ProfileLinkedAccountsScreen/ProfileLinkedAccountsScreen';
import ProfileInviteFriendsScreen from './components/screens/ProfileInviteFriendsScreen/ProfileInviteFriendsScreen';
import ProfileSupportScreen from './components/screens/ProfileSupportScreen/ProfileSupportScreen';
import BottomNavigation from './components/navigation/BottomNavigation/BottomNavigation';
import ScrollToTop from './components/utils/ScrollToTop';
import { SavedItemsProvider } from './contexts/SavedItemsContext';
import './App.css';

function App() {
  // TODO: Implement proper auth state management
  const isAuthenticated = window.location.pathname !== '/login';

  return (
    <SavedItemsProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <a href="#main-content" className="skip-link">Skip to main content</a>
          <main id="main-content" className="app-content" role="main">
            <Routes>
            <Route path="/login" element={<LoginScreen />} />
            <Route 
              path="/" 
              element={isAuthenticated ? <Navigate to="/home" /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/home" 
              element={isAuthenticated ? <HomeScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/search" 
              element={isAuthenticated ? <SearchResults /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/list/:id" 
              element={isAuthenticated ? <ListDetail /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/saved" 
              element={isAuthenticated ? <SavedScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/claims" 
              element={isAuthenticated ? <ClaimsSummaryScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/past-claims" 
              element={isAuthenticated ? <PastClaimsScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/claims/:id" 
              element={isAuthenticated ? <ClaimsDetailScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/claims/:claimId/dispute" 
              element={isAuthenticated ? <DisputeClaimScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/profile" 
              element={isAuthenticated ? <ProfileScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/profile/contact-information" 
              element={isAuthenticated ? <ProfileContactInformationScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/profile/subscription" 
              element={isAuthenticated ? <ProfileSubscriptionScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/profile/notifications" 
              element={isAuthenticated ? <ProfileNotificationsSettingScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/profile/payment-methods" 
              element={isAuthenticated ? <ProfilePaymentMethodsScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/profile/linked-accounts" 
              element={isAuthenticated ? <ProfileLinkedAccountsScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/profile/invite-friends" 
              element={isAuthenticated ? <ProfileInviteFriendsScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/profile/support" 
              element={isAuthenticated ? <ProfileSupportScreen /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/provider/:id" 
              element={isAuthenticated ? <ProviderDetail /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/medication/:id" 
              element={isAuthenticated ? <MedicationDetail /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/procedure/:id" 
              element={isAuthenticated ? <ProcedureDetail /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/specialty/:code" 
              element={isAuthenticated ? <SpecialtyDetail /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/ai-search" 
              element={isAuthenticated ? <AISearchResults /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/ai-care-plan/:id" 
              element={isAuthenticated ? <AISearchResultList /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/ai-followup" 
              element={isAuthenticated ? <AISearchFollowup /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/ai-search-result-detail" 
              element={isAuthenticated ? <AISearchResultDetail /> : <Navigate to="/login" />} 
            />
            {/* Medical professional username routes - supports multiple titles */}
            <Route 
              path="/:titles/:username" 
              element={isAuthenticated ? <ProviderDetail /> : <Navigate to="/login" />} 
            />
          </Routes>
        </main>
          {isAuthenticated && window.location.pathname !== '/login' && <BottomNavigation />}
        </div>
      </Router>
    </SavedItemsProvider>
  );
}

export default App;
